import React, {useEffect} from "react";
import DatePicker from "react-datepicker";
import cx from "classnames";
import PropTypes from "prop-types";
import ReactInputMask from "react-input-mask";
import {range, get} from "lodash";
import moment from "moment";
import {useTranslation} from "react-i18next";

import "react-datepicker/dist/react-datepicker.css";

import "./style.scss";

const DatePickerComponent = ({
                                 label,
                                 isRequired,
                                 form: {touched, errors, setFieldValue, setFieldTouched},
                                 field,
                                 variant = "small",
                                 inputClassname,
                                 className,
                                 size = "normal",
                                 format,
                                 popperPlacement = "bottom-end",
                                 calendarStartDay = 1,
                                 placeholder = "YYYY-MM-DD",

                                 popperClassName,
                                 today,
                                 type,
                                 minDate,
                                 handleBlur = () => {
                                 },
                                 handleChange = () => {
                                 },
                                 customChange = false,
                                 showTimeSelect,
                                 timeIntervals,
                                 selectToday = false,
                                 ...props
                             }) => {
    const {t} = useTranslation();

    const selected = field.value ? moment(field.value).toDate() : selectToday ? new Date() : undefined;
    const headerDate = selected ? selected : new Date();
    const isError = touched[field.name] && errors[field.name];

    const years = range(headerDate.getFullYear() - 20, headerDate.getFullYear() + 20, 1);
    const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    useEffect(() => {
        if (selectToday && !field.value) {
            setFieldValue(field.name, new Date());
        }
    }, []);

    const getMask = () => {
        return format
            .replaceAll("y", "9")
            .replaceAll("M", "9")
            .replaceAll("d", "9")
            .replaceAll("H", "9")
            .replaceAll("s", "9")
            .replaceAll("m", "9");
    };

    return (
        <div className={`${className}`}>
            {label && (
                <label className="form-field__label">
                    {label} {isRequired && <span style={{color: "red"}}>*</span>}
                </label>
            )}

            <div className="relative-wrapper">
                <DatePicker
                    {...props}
                    selected={selected}
                    onChange={date => {
                        customChange ? handleChange(date) : setFieldValue(field.name, date);
                    }}
                    onBlur={() => {
                        setFieldTouched(field.name, true);
                        handleBlur();
                    }}
                    popperClassName="modern-datepicker-popper"
                    placeholderText={placeholder}
                    className={cx("custom-datepicker-input", inputClassname, {"input-error": isError},variant)}
                    calendarStartDay={1}
                    dateFormat={format}
                    customInput={
                        <ReactInputMask
                            mask={getMask()}
                            className={cx("custom-datepicker-input", {"input-error": isError})}
                        />
                    }
                />

                <div className="calendar-icon-wrapper">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2"
                         strokeLinecap="round" strokeLinejoin="round">
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                        <line x1="16" y1="2" x2="16" y2="6"></line>
                        <line x1="8" y1="2" x2="8" y2="6"></line>
                        <line x1="3" y1="10" x2="21" y2="10"></line>
                    </svg>
                </div>
            </div>

            {isError && (
                <div className="error-message">{errors[field.name]}</div>
            )}
        </div>
    );
};

DatePickerComponent.propTypes = {
    label: PropTypes.string,
    isRequired: PropTypes.bool,
    form: PropTypes.shape({
        touched: PropTypes.object,
        errors: PropTypes.object,
        setFieldValue: PropTypes.func,
        setFieldTouched: PropTypes.func,
        setFieldError: PropTypes.func
    }),
    variant: PropTypes.oneOf(["extra-small", "small", "normal"]),
    inputClassname: PropTypes.string,
    className: PropTypes.string,
    format: PropTypes.string,
    popperPlacement: PropTypes.string,
    calendarStartDay: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7]),
    placeholder: PropTypes.string,
    popperClassName: PropTypes.string,
    today: PropTypes.bool,
    disabled: PropTypes.bool,
    timeIntervals: PropTypes.number,
    showTimeSelect: PropTypes.bool
};

DatePickerComponent.defaultProps = {
    label: "",
    isRequired: true,
    variant: "small",
    inputClassname: "",
    className: "",
    format: "yyyy-MM-dd",
    popperPlacement: "bottom-end",
    calendarStartDay: 1,
    placeholder: "dd.MM.yyyy",
    popperClassName: "",
    today: true,
    disabled: false,
    timeIntervals: 15,
    showTimeSelect: false
};

export default DatePickerComponent;
